import { ref } from "vue";
import { BASE_URL } from "@/services/api";
import Ls from "@/services/ls";
import i18n from "@/plugins/i18n";

// Récupère la facture PDF d'une commande (même endpoint utilisé côté espace
// client : get/pdf/checkout/{id}) et expose l'état (url/chargement) pour
// l'afficher dans une modale à iframe — même pattern que Contact/View.vue.
// L'affichage/fermeture de la modale elle-même reste à la charge du composant
// appelant (data-bs-dismiss, id de modale...), ce composable ne gère que la
// récupération du PDF.
export function useInvoicePdf() {
    const pdfUrl = ref(null);
    const isLoading = ref(false);

    async function openInvoicePdf(checkoutId) {
        pdfUrl.value = null;
        isLoading.value = true;
        try {
            const response = await window.axios({
                url: BASE_URL + '/get/pdf/checkout/' + checkoutId,
                method: 'GET',
                responseType: 'blob',
                headers: { Authorization: 'Bearer ' + Ls.get('auth.token') }
            })
            const blob = new Blob([response.data], { type: 'application/pdf' })
            pdfUrl.value = window.URL.createObjectURL(blob)
        } catch (e) {
            window.toastr['error'](i18n.global.t('error'))
            throw e
        } finally {
            isLoading.value = false;
        }
    }

    function closeInvoicePdf() {
        if (pdfUrl.value) {
            window.URL.revokeObjectURL(pdfUrl.value);
            pdfUrl.value = null;
        }
    }

    return { pdfUrl, isLoading, openInvoicePdf, closeInvoicePdf }
}
